import {RouteObject} from 'react-router';
import {PricingPage} from '@common/billing/pricing-table/pricing-page';
import {LicensePage} from '../license-page';
import {SubscriptionPage} from '../subscription-page';
import {ShopPage} from '@common/billing/shop/shop-page';
import {PaymentSuccessPage} from '../payment-success-page';
import {PaymentCancelledPage} from '../payment-cancelled-page';
import {CheckoutPage} from '../checkout-page';
import React from 'react';

const lazyRoute = async (
  cmp: keyof typeof import('@common/billing/billing-page/routes/billing-page-routes.lazy'),
) => {
  const exports = await import(
    '@common/billing/billing-page/routes/billing-page-routes.lazy'
  );
  return {
    Component: exports[cmp],
  };
};

export const billingPageRoutes: RouteObject[] = [
  {
    path: 'pricing',
    element: <PricingPage />,
  },
  {
    path: 'shop',
    lazy: () => lazyRoute('BillingSidebarLayout'),
    children: [
      {
        index: true,
        element: <ShopPage />,
      },
    ],
  },
  {
    path: 'payment-success',
    element: <PaymentSuccessPage />,
  },
  {
    path: 'payment-cancelled',
    element: <PaymentCancelledPage />,
  },
  {
    path: 'checkout',
    element: <CheckoutPage />,
  },
  {
    path: 'my-settings',
    lazy: () => lazyRoute('BillingSidebarLayout'),
    children: [
      {
        index: true,
        lazy: () => lazyRoute('BillingPage'),
      },
      {
        path: 'licenses',
        element: <LicensePage />,
      },
      {
        path: 'subscriptions',
        element: <SubscriptionPage />,
      },
      {
        path: 'change-payment-method',
        lazy: () => lazyRoute('ChangePaymentMethodLayout'),
        children: [
          {
            index: true,
            lazy: () => lazyRoute('ChangePaymentMethodPage'),
          },
          {
            path: 'done',
            lazy: () => lazyRoute('ChangePaymentMethodDone'),
          },
        ],
      },
      {
        path: 'change-plan',
        lazy: () => lazyRoute('ChangePlanPage'),
      },
      {
        path: 'change-plan/:productId/:priceId/confirm',
        lazy: () => lazyRoute('ConfirmPlanChangePage'),
      },
      {
        path: 'cancel',
        lazy: () => lazyRoute('ConfirmPlanCancellationPage'),
      },
      {
        path: 'renew',
        lazy: () => lazyRoute('ConfirmPlanRenewalPage'),
      },
    ],
  },
];